export function createReaderAnnotationToolbarBridge({
  ensureReaderAnnotationToolbarModuleReady,
  invokeReaderAnnotationToolbar,
  getReaderAnnotationToolbarModuleApi,
  showToast
}) {
  function setupSelectionToolbar() {
    invokeReaderAnnotationToolbar('setupSelectionToolbar');
  }

  async function handleHighlight() {
    try {
      const mod = await ensureReaderAnnotationToolbarModuleReady();
      await mod?.handleHighlight?.();
    } catch (error) {
      showToast?.('标注工具加载失败');
    }
  }

  function bindIframeSelectionEvents() {
    invokeReaderAnnotationToolbar('bindIframeSelectionEvents');
  }

  function restoreSavedMarks() {
    invokeReaderAnnotationToolbar('restoreSavedMarks');
  }

  function hideSelectionToolbar() {
    getReaderAnnotationToolbarModuleApi()?.hideSelectionToolbar?.();
  }

  return {
    setupSelectionToolbar,
    handleHighlight,
    bindIframeSelectionEvents,
    restoreSavedMarks,
    hideSelectionToolbar
  };
}
